import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-side-panel-label]',
    standalone: false
})
export class KuiSidePanelLabelDirective {
  @HostBinding('class.mb-0') noMarginBottom = true;
}
